// Components
import Button from '../Button/Button';

// Data utils
import getShareOptionsData from '../../utils/data/getShareOptionsData';

const shareOptionClick = (e, option) => {
  e.preventDefault();

  const url = encodeURI(window.location.href);

  // Get title from og:title, document.title is way too long
  let title = document.querySelector('meta[property="og:title"]').content;
  title = title.replace('#', '%23'); // make sure title does not get cut of when encounterig '#'

  // Share to LinkedIn, Twitter and Email
  if (option.href) {
    const link = option.href.replace('{url}', url).replace('{title}', title);
    window.open(link, '_blank');
  }

  // Copy url to clipboard
  if (option.type === 'copylink') {
    const copyText = () => navigator.clipboard.writeText(url);
    const copyTextFallback = () => document.execCommand('copy');
    if (navigator && navigator?.clipboard) {
      copyText();
    } else {
      copyTextFallback();
    }
    const copyLinkButton = e.currentTarget;
    copyLinkButton.classList.add('is-copied');
    copyLinkButton.querySelector('.Button-labelText').innerHTML = 'Link copied to clipboard';

    setTimeout(() => {
      copyLinkButton.classList.remove('is-copied');
      copyLinkButton.querySelector('.Button-labelText').innerHTML = 'Copy link';
    }, 3000);
  }
};

const ShareOptions = ({ element }) => {
  const shareOptionsData = getShareOptionsData();

  const shareOptions = shareOptionsData.map((option) => (
    <div
      key={`ImpactBlock-button--${option.label}`}
      className={`ShareOptions-option ShareOptions-option--${option.type}`}
    >
      <Button
        label={option.label}
        url="#"
        modifier="Button--electricPurple"
        icon={option.icon}
        onClick={(e) => {
          if (element.onSubmit) {
            element.onSubmit(option.type);
          }
          shareOptionClick(e, option);
        }}
        skipAnimation
      />
    </div>
  ));

  return <div className="ShareOptions">{shareOptions}</div>;
};

export default ShareOptions;
